const User = () => import('../views/UserManage/user/index.vue');
export default [
  {
    path: '/promoter',
    name: '推广员管理',
    component: User,
    meta: [{ name: '推广员管理' }],
  },
];